export default (urlParameters) => {
  const baseConfiguration = {
    // -- LIFESTYLE API URL
    baseUrl: import.meta.env.VITE_LIFESTYLE_API_URL_PROD, // Production
    // baseUrl: import.meta.env.VITE_LIFESTYLE_API_URL_DEV, // Development

    // -- TEMPEST API URL
    tempestRestApiUrl: import.meta.env.VITE_TEMPEST_REST_API_URL_PROD, // Production
    // tempestRestApiUrl: import.meta.env.VITE_TEMPEST_REST_API_URL_DEV, // Development

    // -- TEMPEST WEBSOCKET API URL
    tempestWSApiUrl: import.meta.env.VITE_TEMPEST_WEBSOCKET_API_URL_PROD, // Production
    // tempestWSApiUrl: import.meta.env.VITE_TEMPEST_REST_API_URL_DEV, // Development

    // -- MAP TILES
    mmrsApiUrl: import.meta.env.VITE_MAP_TILES_URL_CDN_PROD, // Production CDN
    // mmrsApiUrl: import.meta.env.VITE_MAP_TILES_URL_DIRECT_PROD, // Direct from Server. Don't use this one.
    // mmrsApiUrl: import.meta.env.VITE_MAP_TILES_URL_DEV, // Development

    // -- STORM/HURRICANE DATA URLS
    storm_track_data_url: import.meta.env.VITE_STORM_TRACK_DATA_URL_PROD, // Production
    // storm_track_data_url: import.meta.env.VITE_STORM_TRACK_DATA_URL_DEV, // Development

    // -- STORM/HURRICANE DATA FILE
    storm_track_data_file: import.meta.env.VITE_STORM_TRACK_DATA_FILE_PROD, // Production
    // storm_track_data_file: import.meta.env.VITE_STORM_TRACK_DATA_FILE_DEV, // Development

    // -- STORM/PLOT DATA URL
    storm_track_plot_data_url: import.meta.env.VITE_STORM_TRACK_PLOT_DATA_URL_PROD, // Production

    // -- STORM/PLOT DATA FILE
    storm_track_plot_data_file: import.meta.env.VITE_STORM_TRACK_PLOT_DATA_FILE_PROD, // Production
    // storm_track_plot_data_file: import.meta.env.VITE_STORM_TRACK_PLOT_DATA_FILE_DEV, // Development

    apiKey: import.meta.env.VITE_LIFESTYLE_API_KEY,
    facebookAppId: import.meta.env.VITE_FACEBOOK_APP_ID,
    mrmsApiKey: import.meta.env.VITE_MAP_TILES_API_KEY,
    tempestApiKey: import.meta.env.VITE_TEMPEST_API_KEY,
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    googleAnalyticsId: import.meta.env.VITE_GA4_ID,

    aibProviders: [1370],
    app_type: 'consumer',
    brand: import.meta.env.VITE_BRAND,
    is_ops_console: false,
    markerColorByMesonet: false,
    showStationCode: false,
    showTempestMeta: false,
    siteDomain: null,
    siteName: import.meta.env.VITE_SITENAME,
    tempestProviders: [1046, 1047],
    token: import.meta.env.VITE_TOKEN,
    tokenDomain: null
  }
  
  baseConfiguration.env =
    window.location.host.indexOf('development') > -1 ||
    window.location.host.indexOf('local') > -1 ||
    window.location.protocol === 'file:'
      ? 'development'
      : 'production'

  return baseConfiguration
}


